import { TModifier } from '../../../../packages/Filters';

export const GEO_CHANGE_ACTIONS: TModifier['action'][] = [
  'clearGeo',
  'selectGeo',
  'removeGeo',
  'setBSCenter',
  'setRegion',
  'setVillage',
];
